import { LoginSchema } from "@milespay.co/validations";
import { createContext, PropsWithChildren } from "react";
import { useMilespayAPI } from "../hooks";
import { isAxiosError } from "axios";
import { MILESPAY_TOKEN_NAME } from "../services";
import { CircularProgress, useTheme } from "@mui/material";

interface User {
    id: string
    name: string
    email: string
}

interface AuthContextValues {
    signed: boolean,
    isLoading: boolean,
    signIn: (values: typeof LoginSchema.__outputType) => Promise<boolean>
    signOut: () => void
    me: User | null,
    refetchMe: () => void
}

const AuthContext = createContext({} as AuthContextValues)

export const AuthContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const theme = useTheme()

    const [me, refetchMe] = useMilespayAPI('/auth/me')

    const [api, apiControls] = useMilespayAPI({}, { manual: true })

    if (me.loading || api.loading) {
        return (
            <div style={{
                display: 'flex',
                flex: '1',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                width: '100vw',
                backgroundColor: theme.palette.background.default
            }}>
                <CircularProgress />
            </div>
        )
    }

    const signIn = async (data: typeof LoginSchema.__outputType) => {
        console.log('data', data, apiControls)
        const auth = await apiControls({
            url: '/auth/signin',
            data,
            method: 'POST'
        })
        console.log('auth', auth)

        window.localStorage.setItem(MILESPAY_TOKEN_NAME, auth.data.token)

        return !isAxiosError(auth)
    }

    const signOut = () => {
        window.localStorage.removeItem(MILESPAY_TOKEN_NAME)

        return window.location.href = '/login'
    }

    return (
        <AuthContext.Provider value={{ 
            isLoading: api.loading,
            me: me.data || null,
            signed: Boolean(me.data),
            signIn,
            signOut,
            refetchMe
        }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContext;